export const CVP = {
  advanceBooking: 'advanceBooking',
  affordability: 'affordability',
  billPay: 'billPay',
  bossClub: 'bossClub',
  brand: 'brand',
  breakfastPromos: 'breakfastPromos',
  cashlessPayment: 'cashlessPayment',
  cheapEats: 'cheapEats',
  deliveryGuarantee: 'deliveryGuarantee',
  digibank: 'digibank',
  digitalGoods: 'digitalGoods',
  dineOutBookTable: 'dineOutBookTable',
  dineOutDeals: 'dineOutDeals',
  dineOutDiscounts: 'dineOutDiscounts',
  dineOutVouchers: 'dineOutVouchers',
  discover: 'discover',
  doubleDigitDays: 'doubleDigitDays',
  familyAccount: 'familyAccount',
  gFinPaxCashLoan: 'gFinPaxCashLoan',
  gameVoucher: 'gameVoucher',
  gfb: 'gfb',
  goNow: 'goNow',
  grabBike: 'grabBike',
  grabBikeHemat: 'grabBikeHemat',
  grabBikePlus: 'grabBikePlus',
  grabBikeSaver: 'grabBikeSaver',
  grabBikeStandard: 'grabBikeStandard',
  grabBikeTietKiem: 'grabBikeTietKiem',
  grabCar: 'grabCar',
  grabCarHemat: 'grabCarHemat',
  grabCarPlus: 'grabCarPlus',
  grabCarPremium: 'grabCarPremium',
  grabCarSaver: 'grabCarSaver',
  grabCarStandard: 'grabCarStandard',
  grabCarTietKiem: 'grabCarTietKiem',
  grabCarXl: 'grabCarXl',
  grabCoins: 'grabCoins',
  grabCoinsBurn: 'grabCoinsBurn',
  grabCoinsEarn: 'grabCoinsEarn',
  grabExpress: 'grabExpress',
  grabExpressCar: 'grabExpressCar',
  grabExpressInstant: 'grabExpressInstant',
  grabExpressInstantHemat: 'grabExpressInstantHemat',
  grabExpressSameDay: 'grabExpressSameDay',
  grabExpressSellersClub: 'grabExpressSellersClub',
  grabFood: 'grabFood',
  grabFood5Star: 'grabFood5Star',
  grabForFamily: 'grabForFamily',
  grabForGood: 'grabForGood',
  grabForPets: 'grabForPets',
  grabJastip: 'grabJastip',
  grabMart: 'grabMart',
  grabMartGrocer: 'grabMartGrocer',
  grabMartKilat: 'grabMartKilat',
  grabMartNewToMart: 'grabMartNewToMart',
  grabMartSaverDelivery: 'grabMartSaverDelivery',
  grabMore: 'grabMore',
  grabNow: 'grabNow',
  grabPayWallet: 'grabPayWallet',
  grabRides: 'grabRides',
  grabShare: 'grabShare',
  grabShop: 'grabShop',
  grabSignatures: 'grabSignatures',
  grabThumbsUp: 'grabThumbsUp',
  grabUnlimited: 'grabUnlimited',
  grabUnlimitedFreeDelivery: 'grabUnlimitedFreeDelivery',
  grabUnlimitedNonSubs: 'grabUnlimitedNonSubs',
  grabVip: 'grabVip',
  greenProgrammeContribution: 'greenProgrammeContribution',
  groupOrder: 'groupOrder',
  groupRides: 'groupRides',
  habitual: 'habitual',
  humansOfGrab: 'humansOfGrab',
  hvr: 'hvr',
  jayaGrocer: 'jayaGrocer',
  laaS: 'laaS',
  localLife: 'localLife',
  multiStopRides: 'multiStopRides',
  multiTaxiType: 'multiTaxiType',
  omg: 'omg',
  ongkirUnlimitedSubscription: 'ongkirUnlimitedSubscription',
  onlyOnGrabFood: 'onlyOnGrabFood',
  ovoCashlessPayment: 'ovoCashlessPayment',
  ovoPayLater: 'ovoPayLater',
  payLater: 'payLater',
  pickup: 'pickup',
  plnPrepaid: 'plnPrepaid',
  priorityBooking: 'priorityBooking',
  priorityDelivery: 'priorityDelivery',
  pulsaPaketData: 'pulsaPaketData',
  reliability: 'reliability',
  rideCover: 'rideCover',
  rideCover24Hours: 'rideCover24Hours',
  riderCoverOrRideCoverPlus: 'riderCoverOrRideCoverPlus',
  safety: 'safety',
  saverDelivery: 'saverDelivery',
  saverServices: 'saverServices',
  scheduleOrder: 'scheduleOrder',
  scheduleRide: 'scheduleRide',
  sustainability: 'sustainability',
  tanTanTan: 'tanTanTan',
  teaTime: 'teaTime',
  tokenListrik: 'tokenListrik',
  travelCover: 'travelCover',
  travelGuide: 'travelGuide',
  wideSelection: 'wideSelection',
};


export const CVP_DISPLAY_NAMES = {
  advanceBooking: 'Grab Advance Booking',
  affordability: 'Affordability',
  billPay: 'Billpay',
  bossClub: 'Boss Club',
  brand: 'Brand',
  breakfastPromos: 'Breakfast Promos',
  cashlessPayment: 'Cashless Payment',
  cheapEats: 'Cheap Eats',
  deliveryGuarantee: 'Delivery Guarantee',
  digibank: 'Digibank',
  digitalGoods: 'Digital Goods',
  dineOutBookTable: 'Book Table with Dine Out',
  dineOutDeals: 'Dine Out Deals',
  dineOutDiscounts: 'Dine out discounts',
  dineOutVouchers: 'Dine Out vouchers',
  discover: 'Discover',
  doubleDigitDays: 'Double Digit Days',
  familyAccount: 'Grab for Family Account',
  gFinPaxCashLoan: 'GFIN Pax Cash Loan',
  gameVoucher: 'Game Voucher',
  gfb: 'GFB',
  goNow: 'GoNow',
  grabBike: 'GrabBike',
  grabBikeHemat: 'GrabBike Hemat',
  grabBikePlus: 'GrabBike Plus',
  grabBikeSaver: 'GrabBike Saver',
  grabBikeStandard: 'GrabBike Standard',
  grabBikeTietKiem: 'GrabBike Tiết Kiệm',
  grabCar: 'GrabCar',
  grabCarHemat: 'GrabCar Hemat',
  grabCarPlus: 'GrabCar Plus',
  grabCarPremium: 'GrabCar Premium',
  grabCarSaver: 'GrabCar Saver',
  grabCarStandard: 'GrabCar Standard',
  grabCarTietKiem: 'GrabCar Tiết Kiệm',
  grabCarXl: 'GrabCar XL',
  grabCoins: 'GrabCoins',
  grabCoinsBurn: 'GrabCoins Burn',
  grabCoinsEarn: 'GrabCoins Earn',
  grabExpress: 'GrabExpress',
  grabExpressCar: 'GrabExpress Car',
  grabExpressInstant: 'GrabExpress Instant',
  grabExpressInstantHemat: 'GrabExpress Instant Hemat',
  grabExpressSameDay: 'GrabExpress Same Day',
  grabExpressSellersClub: 'GrabExpress Sellers Club',
  grabFood: 'GrabFood',
  grabFood5Star: 'Grab 5-Star Eats',
  grabForFamily: 'Grab For Family Account',
  grabForGood: 'GrabForGood',
  grabForPets: 'Grab For Pets',
  grabJastip: 'Grab Jastip',
  grabMart: 'GrabMart',
  grabMartGrocer: 'GrabMart Grocer',
  grabMartKilat: 'GrabMart Kilat',
  grabMartNewToMart: 'GrabMart - NEW2MART',
  grabMartSaverDelivery: 'GrabMart Saver Delivery',
  grabMore: 'GrabMore',
  grabNow: 'GrabNow',
  grabPayWallet: 'GrabPay Wallet',
  grabRides: 'Grab Rides',
  grabShare: 'GrabShare',
  grabShop: 'GrabShop',
  grabSignatures: 'Grab Signatures',
  grabThumbsUp: 'GrabThumbsUp',
  grabUnlimited: 'GrabUnlimited',
  grabUnlimitedFreeDelivery: 'GrabUnlimited Free Delivery',
  grabUnlimitedNonSubs: 'GrabUnlimited (Non GU)',
  grabVip: 'GrabVIP',
  greenProgrammeContribution: 'Green Programme Contribution',
  groupOrder: 'Group Order',
  groupRides: 'GrabCar Group Rides',
  habitual: 'Habitual (Hot Deals)',
  humansOfGrab: 'Humans of Grab',
  hvr: 'HVR',
  jayaGrocer: 'Jaya Grocer',
  laaS: 'LaaS',
  localLife: 'Local Life',
  multiStopRides: 'Multi-Stop Rides',
  multiTaxiType: 'Multi Taxi Type',
  omg: 'OMG',
  ongkirUnlimitedSubscription: 'Ongkir Unlimited Subscription',
  onlyOnGrabFood: 'Only on GrabFood',
  ovoCashlessPayment: 'OVO Cashless Payment',
  ovoPayLater: 'OVO PayLater',
  payLater: 'PayLater',
  pickup: 'Pickup',
  plnPrepaid: 'PLN Prepaid',
  priorityBooking: 'Priority Booking',
  priorityDelivery: 'Priority Delivery',
  pulsaPaketData: 'Pulsa & Paket Data',
  reliability: 'Reliability',
  rideCover: 'Ride Cover',
  rideCover24Hours: 'Ride Cover 24 giờ',
  riderCoverOrRideCoverPlus: 'Ride Cover/Ride Cover+',
  safety: 'Safety',
  saverDelivery: 'Saver Delivery',
  saverServices: 'Saver Services',
  scheduleOrder: 'Schedule Order',
  scheduleRide: 'Grab Advance Booking',
  sustainability: 'Sustainability',
  tanTanTan: 'Tan Tan Tan',
  teaTime: 'Tea Time',
  tokenListrik: 'Token Listrik',
  travelCover: 'Travel Cover',
  travelGuide: 'Travel Guide',
  wideSelection: 'Wide Selection (Only at Grab, GrabThumbsUp)',
};

/*
 * CountryID, country code, and country name:
 *
 *  1: 'MY', 'Malaysia',
 *  2: 'PH', 'Philippines',
 *  3: 'TH', 'Thailand',
 *  4: 'SG', 'Singapore',
 *  5: 'VN', 'Vietnam',
 *  6: 'ID', 'Indonesia',
 *  9: 'MM', 'Myanmar',
 *  10: 'KH', 'Cambodia',
 */
export const CVP_BASED_ON_VERTICAL_AND_COUNTRY_ID = {
  1: {
    digibank: [CVP.digibank],
    digitalGoods: [CVP.digitalGoods],
    express: [CVP.grabExpress],
    food: [
      CVP.grabFood,
      CVP.grabFood5Star,
      CVP.grabSignatures,
      CVP.groupOrder,
      CVP.habitual,
      CVP.saverDelivery,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [
      CVP.grabUnlimited,
      CVP.grabUnlimitedNonSubs,
    ],
    jayaGrocer: [CVP.jayaGrocer],
    mart: [
      CVP.grabMart,
      CVP.grabMartNewToMart,
    ],
    omnicommerce: [
      CVP.dineOutBookTable,
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabForGood,
      CVP.grabMore,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.advanceBooking,
      CVP.grabCarSaver,
      CVP.grabForFamily,
      CVP.grabRides,
      CVP.groupRides,
    ],
  },
  2: {
    digitalGoods: [CVP.digitalGoods],
    express: [CVP.grabExpress],
    food: [
      CVP.grabFood,
      CVP.grabFood5Star,
      CVP.grabSignatures,
      CVP.groupOrder,
      CVP.saverDelivery,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [
      CVP.grabUnlimited,
      CVP.grabUnlimitedNonSubs,
    ],
    mart: [CVP.grabMart],
    omnicommerce: [
      CVP.dineOutBookTable,
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabMore,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.advanceBooking,
      CVP.familyAccount,
      CVP.grabCarSaver,
      CVP.grabRides,
      CVP.groupRides,
      CVP.travelGuide,
    ],
  },
  3: {
    digitalGoods: [CVP.digitalGoods],
    express: [
      CVP.grabExpress,
      CVP.grabExpressSellersClub,
    ],
    finance: [CVP.grabPayWallet],
    food: [
      CVP.grabFood,
      CVP.grabSignatures,
      CVP.grabThumbsUp,
      CVP.groupOrder,
      CVP.habitual,
      CVP.saverDelivery,
      CVP.wideSelection,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [CVP.grabUnlimited],
    mart: [CVP.grabMart],
    omnicommerce: [
      CVP.dineOutBookTable,
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabMore,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.advanceBooking,
      CVP.familyAccount,
      CVP.grabBike,
      CVP.grabBikeSaver,
      CVP.grabCar,
      CVP.grabCarSaver,
      CVP.grabRides,
      CVP.groupRides,
      CVP.hvr,
      CVP.reliability,
      CVP.saverServices,
    ],
  },
  4: {
    digibank: [CVP.digibank],
    digitalGoods: [CVP.digitalGoods],
    express: [CVP.grabExpress],
    finance: [
      CVP.doubleDigitDays,
      CVP.payLater,
      CVP.travelCover,
    ],
    food: [
      CVP.grabFood,
      CVP.grabFood5Star,
      CVP.grabSignatures,
      CVP.groupOrder,
      CVP.localLife,
      CVP.saverDelivery,
      CVP.teaTime,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [
      CVP.grabUnlimited,
      CVP.grabUnlimitedFreeDelivery,
      CVP.grabUnlimitedNonSubs,
    ],
    mart: [
      CVP.grabMart,
      CVP.grabMartGrocer,
      CVP.grabMartSaverDelivery,
    ],
    omnicommerce: [
      CVP.dineOutBookTable,
      CVP.dineOutDeals,
      CVP.dineOutDiscounts,
      CVP.dineOutVouchers,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabForPets,
      CVP.grabMore,
      CVP.humansOfGrab,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.advanceBooking,
      CVP.familyAccount,
      CVP.grabCarPremium,
      CVP.grabRides,
      CVP.grabShare,
      CVP.groupRides,
    ],
  },
  5: {
    digitalGoods: [CVP.digitalGoods],
    express: [
      CVP.bossClub,
      CVP.grabExpress,
    ],
    finance: [
      CVP.gFinPaxCashLoan,
      CVP.rideCover,
      CVP.rideCover24Hours,
    ],
    food: [
      CVP.grabFood,
      CVP.grabFood5Star,
      CVP.grabSignatures,
      CVP.groupOrder,
      CVP.priorityDelivery,
      CVP.saverDelivery,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [CVP.grabUnlimited],
    mart: [CVP.grabMart],
    omnicommerce: [
      CVP.dineOutBookTable,
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabMore,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.familyAccount,
      CVP.grabBike,
      CVP.grabBikePlus,
      CVP.grabBikeStandard,
      CVP.grabBikeTietKiem,
      CVP.grabCar,
      CVP.grabCarPlus,
      CVP.grabCarStandard,
      CVP.grabCarTietKiem,
      CVP.grabRides,
      CVP.groupRides,
      CVP.multiStopRides,
      CVP.scheduleRide,
    ],
  },
  6: {
    digitalGoods: [
      CVP.billPay,
      CVP.gameVoucher,
      CVP.plnPrepaid,
      CVP.pulsaPaketData,
      CVP.tokenListrik,
    ],
    express: [
      CVP.deliveryGuarantee,
      CVP.grabExpress,
      CVP.grabExpressCar,
      CVP.grabExpressInstant,
      CVP.grabExpressInstantHemat,
      CVP.grabExpressSameDay,
      CVP.grabJastip,
      CVP.grabShop,
      CVP.ongkirUnlimitedSubscription,
    ],
    finance: [
      CVP.cashlessPayment,
      CVP.ovoCashlessPayment,
      CVP.ovoPayLater,
      CVP.riderCoverOrRideCoverPlus,
    ],
    food: [
      CVP.discover,
      CVP.grabFood,
      CVP.grabFood5Star,
      CVP.grabSignatures,
      CVP.groupOrder,
      CVP.pickup,
      CVP.saverDelivery,
      CVP.scheduleOrder,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [
      CVP.grabUnlimited,
      CVP.grabUnlimitedNonSubs,
    ],
    mart: [
      CVP.grabMart,
      CVP.grabMartKilat,
    ],
    omnicommerce: [
      CVP.dineOutBookTable,
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabMore,
      CVP.greenProgrammeContribution,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.advanceBooking,
      CVP.familyAccount,
      CVP.grabBike,
      CVP.grabBikeHemat,
      CVP.grabCar,
      CVP.grabCarHemat,
      CVP.grabCarPlus,
      CVP.grabCarPremium,
      CVP.grabCarXl,
      CVP.grabNow,
      CVP.grabRides,
      CVP.groupRides,
      CVP.multiStopRides,
      CVP.multiTaxiType,
      CVP.priorityBooking,
    ],
  },
  9: {
    digitalGoods: [CVP.digitalGoods],
    express: [CVP.grabExpress],
    food: [
      CVP.breakfastPromos,
      CVP.cheapEats,
      CVP.grabFood,
      CVP.grabSignatures,
      CVP.omg,
      CVP.onlyOnGrabFood,
      CVP.tanTanTan,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [CVP.grabUnlimited],
    mart: [CVP.grabMart],
    omnicommerce: [
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabMore,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.familyAccount,
      CVP.grabRides,
      CVP.groupRides,
      CVP.safety,
    ],
  },
  10: {
    digitalGoods: [CVP.digitalGoods],
    express: [CVP.grabExpress],
    food: [
      CVP.affordability,
      CVP.grabFood,
      CVP.grabSignatures,
      CVP.grabThumbsUp,
    ],
    gfb: [CVP.gfb],
    grabUnlimited: [CVP.grabUnlimited],
    mart: [CVP.grabMart],
    omnicommerce: [
      CVP.dineOutDeals,
      CVP.laaS,
    ],
    oneGrab: [
      CVP.brand,
      CVP.grabMore,
      CVP.sustainability,
    ],
    rewards: [
      CVP.grabCoins,
      CVP.grabCoinsBurn,
      CVP.grabCoinsEarn,
      CVP.grabVip,
    ],
    transport: [
      CVP.advanceBooking,
      CVP.familyAccount,
      CVP.goNow,
      CVP.grabRides,
      CVP.groupRides,
    ],
  },
};
